// extracted by mini-css-extract-plugin
module.exports = {"row":"ResultFooter_row__359DZ","title":"ResultFooter_title__3BJmQ","load":"ResultFooter_load__3tL7b"};